import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import fetch from './../../fetch';
import { baseUrl, customHeaders } from '../../../../Containers/Config/index.js';

import { GET_STATIC_COUPON, GET_STATIC_COUPON_SUCCESS, GET_STATIC_COUPON_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant';

function* getStaticCoupons({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/coupons`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        ...payload.urlParam,
        pageSize: Constant?.TABLE_PAGE_SIZE,
        static: true,
      },
    });

    if (response.status === 200) {
      yield put({ type: GET_STATIC_COUPON_SUCCESS, payload: response?.data });
    } else {
      yield put({
        type: GET_STATIC_COUPON_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_STATIC_COUPON_ERROR, payload: error });
  }
}

export function* watchGetStaticCoupons() {
  yield takeEvery(GET_STATIC_COUPON, getStaticCoupons);
}

function* getStaticCouponsSaga() {
  yield all([fork(watchGetStaticCoupons)]);
}

export default getStaticCouponsSaga;
